import React from 'react';
import { Container, MessageBody } from './MessageBar.style';
import { icons } from 'seal-ui-components';

export const MessageBar = props => {
    return (
        <Container {...props}>
            <icons.InfoSmallIcon style={{ marginRight: 5 }} />
            <MessageBody>{props.message}</MessageBody>
        </Container>
    );
};
